module.exports = __webpack_public_path__ + "img/secondary_6x3_z16.8687deb6.svg";